import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=688d7d5f&scoped=true&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"
import style0 from "./Create.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Create.vue?vue&type=style&index=1&id=688d7d5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688d7d5f",
  null
  
)

export default component.exports